/**
 * @author PengWen
 * @description zoneCode管理新增、编辑页面
 * @Date 2022/10/21
 */
 import React from 'react';
 import { connect } from 'dva';
 import { framework_tool, component_tool,utils_tool } from '@/tool'
import wizTableForm from '../../common/wizTableForm/wizTableForm';
 let { WizContainer, modelUtils } = framework_tool;
 let { WizCard, WizForm, WizSpin } = component_tool;
 let { Session } = utils_tool
 const organizationConfig = wizTableForm.Config.organization(this, { apiParams: { state: 1, organizationNodeCategory: ["4"] } })

 
 class OrganizationZoneCodeDetail extends WizContainer {
 
   componentName = 'OrganizationZoneCodeDetail';
 
   constructor(props) {
     super(props);
     const { history } = props;
     let initialValue = {};
     let zoneCodeState = 1;
     let cardTitle = '新增'
     if (history.location && history.location.pathname === '/org/zoneCode/zoneCodeUpd') {
       if(history.location && history.location.record){
         initialValue = history.location.record;
         zoneCodeState = initialValue.state;
         Session.set('zoneCodeUpd',initialValue)
         Session.set('zoneCodeState',zoneCodeState)
       }else{
         initialValue = Session.get('zoneCodeUpd') || {};
         zoneCodeState = Session.get('zoneCodeState') || 1;
       }
       cardTitle = '编辑'
     }
     this.state = {
       cardTitle,
       name: null
     }
     this.zoneCodeState = zoneCodeState;
     this.initialValue = initialValue;
   }
 
   propsAndStateOnChange = {
    addZoneCode: this._addZoneCodeOver.bind(this)
   }
 
   _addZoneCodeOver(nextProps, nextState) {
     if (nextProps.addZoneCode.code == 1) {
       wizNotice.success('保存成功');
       this.jumpPage('replace', '/org/zoneCode');
     } else {
       wizNotice.error('提交失败：' + nextProps.addZoneCode.msg);
     }
     return true;
   }
 
   _saveZoneCode(values) {
     const { history } = this.props;
     let apiPath = "OrganizationZoneCode/add";
     if (history.location && history.location.pathname === '/org/zoneCode/zoneCodeUpd') {
       apiPath = "OrganizationZoneCode/update"
     }
     this.doAction({
       path: apiPath,
       payload: {
         key: "addZoneCode",
         apiParams: {
           ...values
         }
       }
     });
   }
 
   _render(other = {}) {
     const { zoneCodeLoading } = this.props;
     let { cardTitle, positionCategoryList } = this.state;
       let columns = [
             {
               formItem: {
                 type: "hidden",
                 initialValue: this.initialValue.id
               },
               name: "id"
             },
             {
                title: '所属组织',
                name: 'orgId',
                formItem: {
                  ...organizationConfig,
                  diy: wizTableForm,
                  initialValue: this.initialValue.orgId,
                  initRows: [{ ...this.initialValue, id: this.initialValue.orgId, name: this.initialValue.orgName }],
                  selectType: 'radio',
                  rules: [
                    {
                      required: true,
                      message: '请选择所属组织'
                    }
                  ],
                }
              },
             {
               title: "zoneCode值",
               name: "zoneCode",
               formItem: {
                 rules: [
                   {
                     required: true,
                     message: 'zoneCode值'
                   },
                   {
                     pattern: /^[^\s]*$/,
                     message: 'zoneCode值不能包含空格'
                   },
                   {
                     max : 20,
                     message : 'zoneCode最大长度不能超过20个字符'
                   }
                 ],
                 //placeholder: "zoneCode长度不能超过20个字符。",
                 initialValue: this.initialValue.zoneCode
               }
             },
             {
                title: "状态",
                name: "state",
                dict: [{
                  code: 1,
                  codeName: "有效"
                },
                {
                  code: 0,
                  codeName: "无效"
                }
                ],
                formItem: {
                  initialValue: (self.initialValue && self.initialValue.state === 0) ? self.initialValue.state : 1,
                  type: "radio",
                }
              },
            
           ]
 
     let onSubmit = this._saveZoneCode.bind(this);
 
     let formProps = {
       ref: 'form',
       columns,
       onSubmit,
       record: null,
       preview: null,
       footer: undefined,
       formItemLayout: {
         labelCol: { span: 4 },
         wrapperCol: { span: 17 }
       }
     }
 
     return (
       <WizCard>
       <WizSpin tip={'加载中'} spinning={zoneCodeLoading}>
         <WizForm className={'form-inline'}
         {...formProps} 
         >
         </WizForm>
       </WizSpin>
     </WizCard>
     )
   }
 }
 
 const mapStateToProps = (state, ownProps) => {
   const {OrganizationZoneCode} = state;
   const addZoneCode = modelUtils.getModelEntity(OrganizationZoneCode, "addZoneCode");
   const load = modelUtils.getLoadingState(state, 'zoneCode');
   return {
    addZoneCode : addZoneCode,
     ...load
   }
 };
 
 export default connect(mapStateToProps)(OrganizationZoneCodeDetail);
 
 
 
 
 
 
 
 
 
 
 
 
 
 
 
 
 